'use strict';
module.exports = function px(pxValue) {
	if (!pxValue) {
		return '0px';
	}
	if (Number.isFinite(pxValue)) {
		return `${pxValue}px`;
	}
	const parsed = parseFloat(pxValue);
	if (Number.isFinite(parsed)) {
		return `${parsed}px`;
	}
	return '0px';
};
